import { render, staticRenderFns } from "./VrtSelection.vue?vue&type=template&id=33267758"
import script from "./VrtSelection.vue?vue&type=script&lang=js"
export * from "./VrtSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports